// extracted by mini-css-extract-plugin
export default {"container":"p0-z","heading":"q0-z","links":"r0-z","copy":"s0-z","subCopy":"t0-z","linksLeft":"u0-z","linksCenter":"v0-z","linksRight":"w0-z","link":"x0-z","onlyLink":"y0-z"};